import React, { useState, useContext} from "react";
import logo from "./assets/logo.png";
import { Link } from "react-router-dom";
import dowon from "./assets/arrow-down-sign-to-navigate 1.png";
import Popup from "reactjs-popup";
import AddRaiseModal from "../AddRaiseModal/ApplyModal";

import ConnectButton from "../ConnectButton/ConnectButton";
import { privateNav, publicNav } from "../../utils/navItems";
import MyContext from "../../MyContext";
const NavLayout = ({ buttons, bold, connectButtonText, parentRef }) => {
  const [open, setOpen] = useState(false);
  const [openRaise, setOpenRaise] = useState(false);
  const [user, setUser] = useState(false);
  const {login} = useContext(MyContext);

  const navItems = !user ? publicNav : privateNav;


  const CreatedItems = () => (
    <ul>
      {navItems.map((single, i) => (
        <li key={i}>
          {single?.dropDown?.length ? (
            <>
              <div className="flex items-center  gap-[6px]">
                <Link>{single.label}</Link>
                <img src={dowon} alt="" />
              </div>
              <div className="dropDown-wrap">
                <ul>
                  {single.dropDown.map((dropDownSingle) => (
                    <li>
                      <Link to={dropDownSingle.url}>
                        {" "}
                        <span
                          onClick={() => {
                            setOpen(!open);
                          }}
                        >
                          {dropDownSingle.label}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <Link onClick={() => setOpen((pre) => !pre)} to={single.url}>
              {single.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <div className="h-[80px]">
      <div className="main-nav-wrap  border-b border-[#8A8AA0]/[0.4]">
        <nav className={`nav-warp w-full h-[80px] ${bold && "bold"}`}>
          <div>
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
          <div className="items grow ">
            <CreatedItems></CreatedItems>
          </div>
          <button
            onClick={() => setOpenRaise(true)}
            className="bg-bright-green  w-[128px] h-[29px] flex justify-center items-center p-[8px] rounded-[5px]"
          >
            <span className=" font-bold text-[15px] leading-[18px] text-light-black">
              Add Raise
            </span>
          </button>
          <span className=" font-bold text-[15px] leading-[18px] text-white">
            {console.log(login)}
            {login?`NFT:`+login.tokenId:"Not Logged in"}
          </span>
          <div className="button-wrap">
            <div className="button-container">
              {user && (
                <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
                  <span>R34P</span>
                  <span className="font-black"> $36.65</span>
                </button>
              )}
              <div ref={parentRef} id="connectwallet">
              <ConnectButton
                text={connectButtonText}
                user={user}
                setUser={setUser}
              ></ConnectButton>
              </div>
            </div>
          </div>
          {open && (
            <div
              onClick={() => setOpen(false)}
              className="fixed inset-0  top-0 left-0 z-[15]"
            ></div>
          )}
          <div className="relative menu-wrap">
            <button
              onClick={() => setOpen((pre) => !pre)}
              className="block xl:hidden rounded-sm border p-2 border-main-green "
            >
              <div className="flex justify-center items-end gap-1 flex-col pr-0 nav-icon-wrap">
                <div className="h-[3px] w-[13px] rounded-md"></div>
                <div className="h-[3px] w-[23px] rounded-md"></div>
                <div className="h-[3px] w-[18px] rounded-md"></div>
              </div>
            </button>

            <div
              className={`absolute w-[320px] right-0 top-full mt-[10px] bg-main-black  z-40 rounded-md popup transition-all ${
                open ? "visible opacity-100 block" : "invisible hidden"
              }`}
            >
              <div className="mobile-items py-4">
                <CreatedItems></CreatedItems>
                <div className="flex justify-center  ">
                  <div className="button-container flex-wrap justify-center">
                    {user && (
                      <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
                        <span>R34P</span>
                        <span className="font-black"> $36.65</span>
                      </button>
                    )}
                    <div id="connectwallet">
                    <ConnectButton
                      id="connectbutton"
                      text={connectButtonText}
                      setUser={setUser}
                      user={user}
                    ></ConnectButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <Popup open={openRaise} position="right center">
        <div className="modalOverlay"></div>
        <AddRaiseModal
          open={openRaise}
          setOpen={setOpenRaise}
        ></AddRaiseModal>
      </Popup>
    </div>
  );
};

export default NavLayout;
